var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentType,{tag:"component",attrs:{"get-data-url":_vm.getDataUrl,"save-config-url":_vm.saveConfigUrl,"get-data-with-reset-config-url":_vm.getDataWithResetConfigUrl,"vue-no-data-template":_vm.vueNoDataTemplate,"auto-complete-url":_vm.autoCompleteUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }